import { forwardRef } from "react";
import Button from "react-bootstrap/Button";
import Dropdown from "react-bootstrap/Dropdown";

import Icon from "../icon/Icon";
import T from "../translations/Translations";

import { GUARDIAN_DASHBOARD } from "../../utils/auth/config";
import { logout } from "../../utils/auth/Auth";

/* eslint-disable */
/**
 * @name Hamburger
 * @return {JSX.Element}
 */
const Hamburger = () => {
    /**
     * The forwardRef is important!!
     * Dropdown needs access to the DOM node in order to position the Menu
     * @name hamburgerToggle
     * @param {{node|func}} {children, onClick}
     * @param {node} ref
     * @return {JSX.Element}
     */
    const hamburgerToggle = forwardRef(({ children, onClick }, ref) => (
        <Button
            active={false}
            bsPrefix="btn"
            className="btn btn-small btn-transparent btn-outline"
            ref={ref}
            onClick={(e) => {
                e.preventDefault();
                onClick(e);
            }}
            size="sm"
            type="button"
            variant="outline-light"
        >
            {children}
        </Button>
    ));

    const dashboard = () => {
        window.location.href = GUARDIAN_DASHBOARD;
    };

    return (
        <Dropdown align="end">
            <Dropdown.Toggle as={hamburgerToggle} id="dropdown-custom-components">
                <i className="bi bi-list" style={{ color: "#19608f", fontSize: "2.0rem", fontWeight: "bold" }} />
            </Dropdown.Toggle>
            <Dropdown.Menu>
                <Dropdown.Item href="#">
                    <button
                        aria-label="Dashboard Button"
                        className="btn btn-primary color-override"
                        onClick={dashboard}
                        onKeyDown={dashboard}
                        style={{ width: "100%" }}
                        type="button"
                    >
                        <span className="nav-button-text">
                            {T({ key: "Global_Dashboard" })}
                            <Icon
                                className="nav-button-icon"
                                fill="white"
                                height={20}
                                iconName="HOME"
                                onClick={dashboard}
                                onKeyDown={dashboard}
                            />
                        </span>
                    </button>
                </Dropdown.Item>
                <Dropdown.Item href="#">
                    <button
                        aria-label="Logout Button"
                        className="btn btn-primary color-override"
                        onClick={logout}
                        onKeyDown={logout}
                        style={{ width: "100%" }}
                        type="button"
                    >
                        <span className="nav-button-text">
                            {T({ key: "Main_Nav_LogOut" })}
                            <Icon
                                className="nav-button-icon"
                                fill="white"
                                height={20}
                                iconName="LOGOUT"
                                onClick={logout}
                                onKeyDown={logout}
                            />
                        </span>
                    </button>
                </Dropdown.Item>
                <Dropdown.Header>
                    {/* Helpful Links */}
                    <span style={{ color: "#333", fontSize: "1.1rem" }}>{T({ key: "Main_Nav_HelpfulLinks" })}</span>
                    <hr style={{ margin: "0 0 -2px 0" }} />
                </Dropdown.Header>
                <Dropdown.Item href="https://www.dcsdk12.org/schools-academics/academic-calendars" target="_blank">
                    {/* Academic Calendar */}
                    <i className="bi bi-calendar2-week" /> {T({ key: "Main_Nav_HelpfulLinks_LI_s2" })}
                </Dropdown.Item>
                <Dropdown.Item
                    href="https://www.dcsdk12.org/about/departments/transportation/bus-routes"
                    target="_blank"
                >
                    {/* Bus Routes */}
                    <i className="bi bi-bus-front" /> {T({ key: "Main_Nav_HelpfulLinks_LI_s4" })}
                </Dropdown.Item>
                <Dropdown.Item href="https://dcsd.nutrislice.com/menus-eula" target="_blank">
                    {/* Lunch Menus */}
                    <i className="bi bi-apple" /> {T({ key: "Main_Nav_HelpfulLinks_LI_s6" })}
                </Dropdown.Item>
                <Dropdown.Item href="https://www.myschoolbucks.com/ver2/getmain?requestAction=home" target="_blank">
                    {/* Online Payments */}
                    <i className="bi bi-coin" /> {T({ key: "Main_Nav_HelpfulLinks_LI_s5" })}
                </Dropdown.Item>
                <Dropdown.Item href="https://www.dcsdk12.org/parents-students/resources" target="_blank">
                    {/* Parent Resources */}
                    <i className="bi bi-journals" /> {T({ key: "Main_Nav_HelpfulLinks_LI_s3" })}
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );
};
/* eslint-enable */

export default Hamburger;
